import { Component , ViewEncapsulation } from '@angular/core';
import { FieldType } from '@ngx-formly/core';

@Component({
  selector: 'formly-field-checkbox',
  template: `<label>
  <input type="checkbox" [formControl]="formControl" [formlyAttributes]="field" (change)="onCheckboxChange($event.target.checked)" [checked]="formControl?.value == 'Y'">
</label>`,
  styles: [`
    formly-field-checkbox { float: left; margin-right: 5px;}
  `],
    encapsulation: ViewEncapsulation.None
})
export class FormlyFieldCheckbox extends FieldType {
  onCheckboxChange(checked: boolean) {
    this.formControl.setValue(checked ? 'Y' : 'N');
  }
}